import Model from './Model';
import API from '../Services/API';
import { useToasts } from '../Components/Toasts';

const weatherQueue = [];
let weatherTimeout = null;

const fetchWeather = async (locationAndTime, showError) => {
    return new Promise((resolve, reject) => {
        weatherQueue.push({ locationAndTime, resolve, reject });
        if (weatherTimeout) {
            clearTimeout(weatherTimeout);
        }
        weatherTimeout = setTimeout(() => {
            const queue = weatherQueue.splice(0);
            const locationsAndTimes = queue.map(item => item.locationAndTime);
            API.get('/weather/batch?forecasts='+locationsAndTimes.join('!')).then(data => {
                queue.forEach(item => {
                    item.resolve(data[item.locationAndTime] ?? false);
                });
            }).catch(err => showError(API.parseErrorResponse(err, 'There was an error loading the weather.')));
        }, 100);
    });
}

const useLocationAndTimeForecast = (location, date, time) => {
    const {showError} = useToasts();

    const normalised = [
        location?.latitude?.toFixed(2) ?? null,
        location?.longitude?.toFixed(2) ?? null,
        date ?? null,
        time ? time.split(':')[0] : '12',
    ].join(',');

    return Model({
        alwaysRefresh: false,
        returnDataKey: 'forecast',
        stateKey: ['weather', normalised],
        fetchData: async () => fetchWeather(normalised, showError),
        defaultLoadingError: 'Sorry, there was an error loading the weather.',
    });
}

export {
    useLocationAndTimeForecast,
};
